
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "@/components/ui/sonner";

const ProtocolHandler = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;

    if (!user) {
      // Redirect to login if not authenticated
      toast.error("You need to be logged in to use this feature");
      navigate("/auth", { replace: true });
      return;
    }

    // Get protocol data from URL parameters
    const params = new URLSearchParams(location.search);
    const protocolUrl = params.get("url") || "";
    
    try {
      // Parse the protocol URL to extract relevant information
      // Example: web+brain://entry?id=123
      const url = new URL(protocolUrl);
      const path = url.pathname.replace('//', '');
      const searchParams = new URLSearchParams(url.search);
      
      if (path === 'entry' && searchParams.has('id')) {
        const entryId = searchParams.get('id');
        navigate(`/dashboard/entry/${entryId}`, { replace: true });
      } else {
        // Default to dashboard if no specific action
        navigate("/dashboard", { replace: true });
      }
    } catch (error) {
      console.error("Error processing protocol URL:", error);
      toast.error("Invalid protocol link");
      navigate("/dashboard", { replace: true });
    }
  }, [user, loading, navigate, location.search]);

  return (
    <div className="h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-xl font-medium mb-2">Processing Brain link...</h1>
        <p className="text-muted-foreground">Please wait, you'll be redirected shortly.</p>
      </div>
    </div>
  );
};

export default ProtocolHandler;
